import { FC, HTMLAttributes, MouseEvent, ReactElement, cloneElement, useCallback } from 'react';
import { Location, useLocation, useMatch, useNavigate } from 'react-router';

type Props = Omit<HTMLAttributes<HTMLElement>, 'children'> & {
    children: ReactElement;
    to: string;
    checkIsActive?: (location: Location, to: string) => boolean;
    end?: boolean;
    exact?: boolean;
};

const LinkContainer: FC<Props> = ({
    to,
    checkIsActive,
    children,
    end,
    exact,
    onClick,
    style,
    ...props
}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const routeMatch = useMatch({ path: to, end: end ?? exact ?? true });
    const isActive = checkIsActive ? checkIsActive(location, to) : routeMatch;
    const childOnClick = children.props.onClick;

    const handleClick = useCallback(
        (e: MouseEvent<HTMLElement>) => {
            if (onClick) {
                onClick(e);
            }
            childOnClick?.(e);

            if (!e.defaultPrevented) {
                e.preventDefault();
                navigate(to);
            }
        },
        [childOnClick, navigate, onClick, to]
    );

    return cloneElement(children, {
        ...props,
        href: to,
        onClick: handleClick,
        className: `${children.props.className || ''} ${isActive ? 'active' : ''}`.trim(),
        style: {
            cursor: 'pointer',
            ...children.props.style,
            ...style,
        },
    });
};

export default LinkContainer;
